import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, onUnmounted } from "vue";
import DateRangeSelector from "@/components/ui/date-range/DateRangeSelector.vue";
import { useWeeklyDateRange } from "@/composables/useWeeklyDateRange.ts";
import { useI18n } from "vue-i18n";
import { getISOWeek } from "@/composables/useWeeklyDateRange.ts";
export default {
  __name: 'WeeklyDateRangeSelector',
  props: {
    initialSelectedWeek: {
      type: Object,
      required: false,
      default: null
    },
    selectedWeek: {
      type: Object,
      required: true
    },
    weekRangeLength: {
      type: Number,
      required: false,
      default: 4
    }
  },
  emits: ["update:selected-week"],
  setup(__props, {
    emit: __emit
  }) {
    const {
      t: $tf
    } = useI18n();
    const props = __props;
    const emit = __emit;

    // Use the weekly date range composable
    const {
      currentWeek,
      isPreviousDisabled,
      isNextDisabled,
      getWeeklyRange,
      previousWeek: prevWeek,
      nextWeek: nextWeekFn,
      resetToCurrentWeek: resetWeek
    } = useWeeklyDateRange(props.weekRangeLength);

    // Emit week update with the current week data
    const emitWeekUpdate = () => {
      const weeklyRange = getWeeklyRange();
      emit("update:selected-week", {
        weekNumber: currentWeek.value,
        ...weeklyRange
      });
    };

    // Wrapper functions to emit updates
    const previousWeek = () => {
      prevWeek();
      emitWeekUpdate();
    };
    const nextWeek = () => {
      nextWeekFn();
      emitWeekUpdate();
    };
    const resetToCurrentWeek = () => {
      resetWeek();
      emitWeekUpdate();
    };

    // Initialize with current week
    onMounted(() => {
      // Only set current week if no prop value is provided
      if (!props.initialSelectedWeek) {
        // Initialize with previous 2 weeks
        currentWeek.value = getISOWeek(new Date()) - 2;
        emitWeekUpdate();
      } else {
        currentWeek.value = props.initialSelectedWeek;
        emitWeekUpdate();
      }
    });
    onUnmounted(() => {
      resetToCurrentWeek();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(DateRangeSelector, {
        "display-label": _unref(getWeeklyRange)().label,
        "is-previous-disabled": _unref(isPreviousDisabled),
        "is-next-disabled": _unref(isNextDisabled),
        "previous-label": _unref($tf)('timeManagement.previousWeek.label'),
        "next-label": _unref($tf)('timeManagement.nextWeek.label'),
        "previous-tooltip": _unref($tf)('timeManagement.previousWeek.tooltip'),
        "next-tooltip": _unref($tf)('timeManagement.nextWeek.tooltip'),
        onPrevious: previousWeek,
        onNext: nextWeek,
        onReset: resetToCurrentWeek
      }, null, 8, ["display-label", "is-previous-disabled", "is-next-disabled", "previous-label", "next-label", "previous-tooltip", "next-tooltip"])]);
    };
  }
};